import React, { useEffect, useCallback } from 'react';
import CombinedProjectsBackButton from 'combineProjects/components/CombinedProjectsBackButton';
import CombinedProjectsHeader from 'combineProjects/components/CombinedProjectsHeader';
import CombinedProjectsPartsTable from 'combineProjects/components/CombinedProjectsPartsTable';
import CombinedProjectsTable from 'combineProjects/components/CombinedProjectsTable';
import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import Loader from '__common/components/LoaderComponent';
import { connect, ConnectedProps } from 'react-redux';
import { POPULATE_COMBINED_PROJECTS, GET_COMBINED_PROJECT } from 'actions';
import { state } from '__common/store';

interface CombinedProjectsProps {
  match: {
    params: {
      combinedProjectId: string;
    };
  };
}

type Props = ConnectedProps<typeof connector> & CombinedProjectsProps;

const CombinedProjects: React.FC<Props> = ({ dispatch, match, yourProjects }) => {
  const { combinedProjectId } = match.params;

  useEffect(() => {
    dispatch(GET_COMBINED_PROJECT(combinedProjectId));

    return () => {
      dispatch(POPULATE_COMBINED_PROJECTS({ combined_project: '', parts_list: [], projects: {} }));
    };
  }, [dispatch, combinedProjectId]);

  const findinputsWithUnequalValues = useCallback((arr: any[]) => {
  const keyValuesMap = {};
  const keysToConsider={'client_address': 'client address', 'zipcode': 'zip code', 'product_id': 'product id', 'panel_mfg': 'manufacturer', 'panel_model': 'model', 'risk_category': 'risk category'};
  arr.forEach(obj => {
    Object.keys(keysToConsider).forEach(key => {
          if (obj.hasOwnProperty(key)) {
              if (!keyValuesMap.hasOwnProperty(key)) {
                  keyValuesMap[key] = [];
              }
              keyValuesMap[key].push(obj[key]);
          }
      });
  });

  const keysWithUnequalValues = Object.keys(keysToConsider).filter(key => {
      const uniqueValues = new Set(keyValuesMap[key]);
      return uniqueValues.size > 1;
  }).map(key=>keysToConsider[key]);

    return keysWithUnequalValues;
  }, []);

  const renderPage = useCallback(() => {
    const { combinedPartsList, combinedProjects } = yourProjects;
    const { user: { isStaff } } = state();
    const inputListWithUnequalValues = findinputsWithUnequalValues(combinedProjects);
    
    return (
      <div className="app-content">
        <Header />
        <div className="combined-projects">
          <CombinedProjectsHeader 
            combinedId={combinedProjectId} 
            combinedPartsList={combinedPartsList} 
            inputListWithUnequalValues={inputListWithUnequalValues} 
            isStaff={isStaff}
          />
          <CombinedProjectsTable data={combinedProjects} isStaff={isStaff}/>
          <CombinedProjectsPartsTable data={combinedPartsList} />
        </div>
        <Footer ContainerFooter={CombinedProjectsBackButton} />
      </div>
    );
  }, [yourProjects, combinedProjectId, findinputsWithUnequalValues]);

  if (yourProjects.combinedProjectId === combinedProjectId) {
    return renderPage();
  }

  return (
    <div className="app-content">
      <Header />
      <Loader />
      <Footer ContainerFooter={CombinedProjectsBackButton} />
    </div>
  );
}

const mapStateToProps = (appState: appState) => ({
  yourProjects: appState.yourProjects,
});

const connector = connect(mapStateToProps);

export default connector(CombinedProjects);
